export default "__VITE_ASSET__715cced2__"